import { useEffect, useRef, useState } from 'react';
import Placeholder from 'components/Placeholder';
import getCompanyPageTestId from 'constants/testsIds/companyPage';
import Wrapper from './SingleTickerStyles';

export interface Props {
  symbol: string;
}

const SingleTicker = ({ symbol }: Props) => {
  const container = useRef<HTMLDivElement>(null);
  const ref = useRef(false);
  const [showSkeleton, setShowSkeleton] = useState(true);

  useEffect(() => {
    if (!ref.current) {
      const script = document.createElement('script');
      script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-single-quote.js';
      script.type = 'text/javascript';
      script.async = true;
      script.innerHTML = `
      {
        "symbol": "${symbol}",
        "width": 280,
        "colorTheme": "light",
        "isTransparent": true,
        "locale": "en"
      }`;
      script.onerror = () => setShowSkeleton(false);
      container.current?.appendChild(script);
      ref.current = true;
      setShowSkeleton(false);
    }

    // This effect needs to run only once, when the component is mounted
  }, []);

  return (
    <Wrapper
      className='tradingview-widget-container'
      ref={container}
      data-cy={getCompanyPageTestId('TRADING_VIEW_CONTAINER')}
      aria-label='Market data widget'
    >
      {showSkeleton ? (
        <Placeholder size={{ height: 120, maxWidth: 280 }} />
      ) : (
        <>
          <div className='tradingview-widget-container__widget' />
          <div className='tradingview-widget-copyright'>
            <a
              href='https://www.tradingview.com/'
              rel='noopener nofollow noreferrer'
              target='_blank'
              className='blue-text'
              aria-label='Go to the main page on TradingView website'
              data-cy={getCompanyPageTestId('TRADING_VIEW_REDIRECT')}
            >
              Track all markets on TradingView
            </a>
          </div>
        </>
      )}
    </Wrapper>
  );
};

export default SingleTicker;
